var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-page',[(_vm.tokenValid)?_c('reset-password-form'):(_vm.tokenChecked)?_c('invalid-token'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }